module.exports = __webpack_public_path__ + "img/zzdp-zb-item-demo.75232a07.png";